<script>
	import { Bar } from 'vue-chartjs';
	import { chunk } from 'lodash';

	export default {
		extends: Bar,
		props: ['data', 'totalPropostas'],
		inject: ['vigencia', 'mapVigencia'],
		mounted() {
			console.log(this.vigencia);
			console.log(this.data);
			this.renderChart(
				{
					labels: chunk(
						this.vigencia.map((item) => item.xDate),
						6
					)[1],
					datasets: [
						{
							label: 'Todos',
							backgroundColor: 'rgba(2, 166, 242, 1)',
							// borderColor: 'rgba(2, 166, 242, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.novos,
									'vigencia',
									'qnt'
								),
								6
							)[1],
						},
						{
							label: 'Positivos',
							backgroundColor: '#f44336',
							// borderColor: 'rgba(139, 195, 74, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.ativos,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},
						{
							label: 'Inconclusivo',
							backgroundColor: '#ff9800',
							// borderColor: 'rgba(255, 152, 0, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.suspensos,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},
						{
							label: 'Negativo',
							backgroundColor: '#00a65a',
							// borderColor: 'rgba(244, 67, 54, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.cancelados,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},

						{
							label: 'Exames',
							backgroundColor: 'rgba(0, 0, 0, 0)',
							borderColor: '#01416f',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.totalPropostas,
									'event',
									'total'
								),
								6
							)[1],
							type: 'line',
						},
					],
				},
				{
					responsive: true,
					maintainAspectRatio: false,
				}
			);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/contatos.vue